import React from 'react'

const LabeledNumber = ({label, number}) => {
  return (
    <div>
      <div className="text-xs text-gray-444">{label}</div>
      <div className="text-2xl">{number}</div>
    </div>
  )
}

export { LabeledNumber }